/**
 * Single source of truth for the overall score formula.
 * Used by the screening engine and by the CRM contact form, so an imported screening
 * result keeps exactly the same overall score after it is saved to the CRM.
 */

export const clampScore = (value: unknown): number => {
    const n = Math.round(Number(value));
    if (!Number.isFinite(n)) return 0;
    return Math.min(100, Math.max(0, n));
};

export function computeFinalScore(partials: unknown[]): number {
    if (partials.length === 0) return 0;
    const sum = partials.reduce<number>((acc, v) => acc + clampScore(v), 0);
    return Math.round(sum / partials.length);
}

export type ScoreBand = "strong" | "average" | "weak";

export const scoreBand = (score: number): ScoreBand =>
    score >= 70 ? "strong" : score >= 40 ? "average" : "weak";
